import { ChevronRightIcon } from './ChevronRightIcon';

/**
 * author: Google
 * id A6D25AD4-462B-4185-B739-FBFCD3ACF3C3
 * name chevron-right
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-right.svg
 * tags
 * - Arrow 
 */
export const KeyboardArrowRightIcon = ChevronRightIcon;
export default KeyboardArrowRightIcon